import { CUSTOM, WEEKDAYS, WEEKENDS } from 'constants/restrictions'

export const getDayAndTimeRestrictionCode = type => {
  if (type === CUSTOM) return 'C'
  if (type === WEEKDAYS) return 'B'
  if (type === WEEKENDS) return 'W'

  return ''
}
